/**
 * Залишок менший або рівний цьому порогу (грн) після часткових оплат не показуємо як борг
 * і статус — «Оплачено» (розбіжності курсу / цілих сум).
 */
export const PURCHASE_DEBT_TOLERANCE_UAH = 2;

export function roundMoneyUAH(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n * 100) / 100;
}

/** Фактичний залишок до копійок (для ліміту оплати). */
export function purchaseRawDebtUAH(totalUAH, paidUAH) {
    return roundMoneyUAH(Number(totalUAH) - Number(paidUAH));
}

/**
 * Залишок у таблиці: після оплат дрібниця ≤ порога відображається як 0.
 */
export function purchaseDisplayDebtUAH(totalUAH, paidUAH) {
    const paid = Number(paidUAH);
    const raw = Number(totalUAH) - paid;
    if (!Number.isFinite(raw)) return 0;
    if (raw <= 0) return 0;
    if (paid > 0 && raw <= PURCHASE_DEBT_TOLERANCE_UAH) return 0;
    return roundMoneyUAH(raw);
}

/**
 * paid — повністю закрито (з урахуванням порога, якщо вже були оплати);
 * partial — є оплати, але залишок > порога;
 * debt — немає оплат або залишок великий.
 */
export function purchasePaymentStatus(totalUAH, paidUAH) {
    const total = Number(totalUAH);
    const paid = Number(paidUAH);
    const raw = roundMoneyUAH(total - paid);
    if (!Number.isFinite(raw)) return "debt";
    if (paid === 0) return "debt";
    if (raw <= PURCHASE_DEBT_TOLERANCE_UAH) return "paid";
    return "partial";
}

/** Кількість рядка закупки (кг): до 4 знаків, без float-хвостів (як на сервері). */
export function roundPurchaseItemQty(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return n;
    return Math.round(n * 10000) / 10000;
}

/** Підпис кількості в таблиці / списку закупок. */
export function formatPurchaseQtyForList(value) {
    const n = roundPurchaseItemQty(value);
    if (!Number.isFinite(n)) {
        return value == null || value === "" ? "" : String(value);
    }
    return n.toLocaleString("uk-UA", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
        useGrouping: false
    });
}
